module.exports = __webpack_public_path__ + "img/selected3-min.52954977.png";